import { t } from 'i18next';
import { ContentCard } from '../../atoms/ContentCard';
import { MainPageContent } from '../../i18n/mainPageContent';
import ProjectBlock, { LogoImage, ProjectRole } from './ProjectBlock';
import xero from "./xero_logo.png"
import poe_tree from "./poe_tree_icon.png"
import log_aggregator from "./log_aggregator.png"
import service_nsw from "./service_nsw.png"
import engine from "./game_engine.png"
import muck from "./muck.png"
import space_saboteurs from "./space_saboteurs.gif"

const NSWLogo: LogoImage = {
  image: service_nsw,
  link: "https://www.nsw.gov.au/ministerial-releases/secure-digital-birth-certificate-to-make-it-easier-to-prove-who-you-are"
}
const XeroLogo: LogoImage = {
  image: xero,
  link: "https://www.xero.com/nz/partnerships/stripe/"
}
const GameLogo1: LogoImage = {
  image: engine,
  link: "https://github.com/Ariacell/SimplePiano"
}
const GameLogo2: LogoImage = {
  image: muck,
  link: "https://globalgamejam.org/games/2026/muck-7"
}
const GameLogo3: LogoImage = {
  image: space_saboteurs,
  link: "https://github.com/Ariacell/ScoreInvaders"
}
const PoBLogo: LogoImage = {
  image: poe_tree,
  link: "https://pathofbuilding.community/"
}
const AggregatorLogo: LogoImage = {
  image: log_aggregator,
  link: "https://github.com/Ariacell/GW2EI-Aggregator"
}

export const ProjectsWidget: React.FC<{}> = () => {
  return (
    <>
      <ContentCard style={{ padding: '10px', textAlign: 'center' }}>
        <h2>{t(MainPageContent.recentProjectContributions, { ns: ['main'] })} </h2>
        <ProjectBlock 
        projectNamei18n="NSW Digital Birth Certificate Mobile App"
        logos={[NSWLogo]}
        link="https://www.nsw.gov.au/ministerial-releases/secure-digital-birth-certificate-to-make-it-easier-to-prove-who-you-are"
        projectResponsibilities18n={"Senior team member leading implementation of a secure platform for New South Wales residents to hold digital credentials on their mobile devices."} 
        techStackItems={["aws", "datadog", "typescript", "terraform", "bash", "docker", "python"]}
        role={ProjectRole.seniorDev}
        />

        <ProjectBlock
        projectNamei18n="XERO Payment platform integrations"
        link="https://www.xero.com/nz/partnerships/stripe/"
        projectResponsibilities18n="Integrate secure and resilient payment flows between Xero and various payment platforms (e.g. Stripe), consulting on systems architecture, resiliency strategies, and ways of working"
        techStackItems={["dotnet", "docker", "k8s","react", "nodejs", 'typescript', "kafka", "terraform" ,"sumologic", "newrelic"]}
        logos={[XeroLogo]}
        role={ProjectRole.seniorDev}
        />

        <ProjectBlock
        projectNamei18n="Games Jams and Solo Development"
        link="https://github.com/Ariacell/SimplePiano"
        projectResponsibilities18n="Work on various small titles for game jams, and continuous experiments and development on a personal C++/OpenGL engine"
        logos={[GameLogo1,GameLogo3, GameLogo2]}
        techStackItems={["dotnet", "cpp", "godot", "unity", "reaper"]}
        role={ProjectRole.selfLed}
        />

        <ProjectBlock
        projectNamei18n="Path of Building contributor"
        link="https://pathofbuilding.community/"
        projectResponsibilities18n="Assist with various small enhancements and data updates to the Lua based Path of Building platform"
        logos={[PoBLogo]}
        techStackItems={["lua"]}
        role={ProjectRole.volunteerDev}
        />

        <ProjectBlock
        projectNamei18n="Guild Wars 2 competitive logs aggregator"
        link='https://github.com/Ariacell/GW2EI-Aggregator'
        projectResponsibilities18n="Created a standalone tool for generating aggregate data from log files captured in competitive player versus player matches. Experimented with both a TKinter python solution and a NodeJS+Typescript frontend"
        logos={[AggregatorLogo]}
        techStackItems={["typescript", "nodejs", "python"]}
        role={ProjectRole.selfLed}
        />
      </ContentCard>
    </>
  );
};

export default ProjectsWidget;
